import React from 'react';
import { useSubscriptionStatus } from '../hooks/useSubscriptionStatus';
import { useAuth } from '../contexts/AuthContext';
import Paywall from './Paywall';

function SubscriptionGuard({ children }) {
  const { currentUser } = useAuth();
  const { isSubscribed, isLoading, error } = useSubscriptionStatus();

  // Show loading state while checking subscription
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-klorah-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-klorah-primary mx-auto mb-4"></div>
          <p className="text-klorah-text">Checking subscription status...</p>
        </div>
      </div>
    );
  }

  // Show error state if there's an error checking subscription
  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-klorah-background">
        <div className="text-center max-w-md mx-auto p-6">
          <div className="glass-panel p-6">
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">
              Error checking subscription
            </h3>
            <p className="text-klorah-text mb-4">
              {error}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-klorah-primary text-black rounded-lg hover:bg-klorah-primary/90 transition-colors"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  // If user is not logged in, show the children (they'll be handled by auth guard)
  if (!currentUser) {
    return children;
  }

  // If user doesn't have an active subscription, show hard paywall overlay
  if (!isSubscribed) {
    return <Paywall />;
  }

  // User has active subscription, show the protected content
  return children;
}

export default SubscriptionGuard; 